var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.syncStatus),expression:"syncStatus"}],class:_vm._f("productSyncStatusClasses")(_vm.syncStatus,_vm.syncStatusList)},[_vm._v(_vm._s(_vm._f("productSyncLabel")(_vm.syncStatus,_vm.syncStatusList)))])
}
var staticRenderFns = []

export { render, staticRenderFns }